enum EContainerType {
  ExperimentContainer = 0,
  ScreenContainer = 1,
  Microfluidics = 2,
  LCP = 3,
}

export default EContainerType;
